export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
};

export const scrollToBottomWithId = (id) => {
    const chatContainer = document.getElementById(id);
    if (chatContainer) chatContainer.scrollTop = chatContainer.scrollHeight;
};
